<template>
  <expandable header="Renal Function Test (RFT)" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_sodium"
          label="Sodium"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_potassium"
          label="Potassium"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_chloride"
          label="Chloride"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_phosphorous"
          label="Phosphorous"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_magnesium"
          label="Magnesium"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_calcium"
          label="Calcium"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_bun"
          label="BUN"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_urea"
          label="Urea"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.rft_creatinine"
          label="Creatinine"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import InputField from "../../form/InputField.vue";

export default {
  components: { Expandable, InputField },
  props: {
    value: {},
    isDisabled: { default: false, type: Boolean },
  },
  data() {
    return { form: {} };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
  mounted() {
    this.onInput();
  },
};
</script>
